import React from 'react';

interface Props {
  children: React.ReactNode;
}

const PageHeader: React.FC<Props> = ({ children }: Props): JSX.Element => (
  <div className="header-wrapper" id="header-wrapper">
    {children}
  </div>
);

export default PageHeader;
